<template>
  <div>
    <v-row>
      <info :info.sync="data.version" title="Version" />
      <info
        :info.sync="data.unit_info[1].value"
        :title="data.unit_info[1].name"
      />
      <info :info.sync="phone" :title="data.unit_info[2].name" phone />
      <info
        :info.sync="data.unit_info[3].value"
        :title="data.unit_info[3].name"
      />
    </v-row>
    <v-row>
      <info
        :info.sync="data.unit_info[4].value"
        :title="data.unit_info[4].name"
        :cols="3"
      />
      <info
        :info.sync="data.unit_info[5].value"
        :title="data.unit_info[5].name"
        :cols="3"
      />
      <info :info.sync="groupName" :title="data.unit_info[6].name" :cols="3" />
      <!-- <info :info.sync="data.unit_info[7].value" :title="data.unit_info[7].name" :cols="3" /> -->
      <info
        :info.sync="data.unit_info[8].value"
        :title="data.unit_info[8].name"
        :cols="3"
        checkbox
      />
    </v-row>
    <div class="d-flex justify-end pt-10 pb-5 pr-5">
      <v-btn
        large
        color="secondary"
        style="width: 40%; color:white;"
        id="current-rental-button"
        @click="_setEditScreen(true)"
        >View Current Rental</v-btn
      >
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Info from '@/components/screens/Info';
import ScreenDetailData from '@/mixins/ScreenDetailData';
import FormatPhone from '@/mixins/FormatPhone';

export default {
  mixins: [ScreenDetailData, FormatPhone],
  components: {
    Info,
  },
  methods: {
    ...mapActions({
      _uploadDetails: 'screenDetails/uploadDetails',
    }),
    ...mapMutations({
      _setEditScreen: 'screens/setEditScreen',
    }),
  },
  computed: {
    ...mapGetters({
      _client: 'account/getCurrentClient',
    }),
    groupName: {
      get() {
        return this._client.groups.find(({ uuid }) => uuid === this.data.unit_info[6].value)
          ? this._client.groups.find(({ uuid }) => uuid === this.data.unit_info[6].value).group_name
          : this.data.unit_info[6].value;
      },
    },
    phone: {
      get() {
        return this.formatPhone(this.data.phone);
      },
      set(val) {
        this.data.phone = val;
      },
    },
  },
};
</script>
